export default {
    data() {
        return {

        }
    },
    methods: {

    }
};



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/case-service/component.js